module.exports = __webpack_public_path__ + "img/wodezhuye.1101cba3.png";